/* tslint:disable */
/* eslint-disable */
/**
 * Easy Templates Internal API
 * This is an internal REST API for Easy Templates application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssuesTree
 */
export interface IssuesTree {
    [key: string]: Array<string> | any;
    /**
     * List of child issue IDs of the root issue
     * @type {Array<string>}
     * @memberof IssuesTree
     */
    root?: Array<string>;
}

/**
 * Check if a given object implements the IssuesTree interface.
 */
export function instanceOfIssuesTree(value: object): value is IssuesTree {
    return true;
}

export function IssuesTreeFromJSON(json: any): IssuesTree {
    return IssuesTreeFromJSONTyped(json, false);
}

export function IssuesTreeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssuesTree {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'root': json['root'] == null ? undefined : json['root'],
    };
}

export function IssuesTreeToJSON(value?: IssuesTree | null): any {
    if (value == null) {
        return value;
    }
    return {
        
            ...value,
        'root': value['root'],
    };
}

